import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    InUseMissionWorkflowVersionDto,
    OrganisationAuthorityDto,
    SimpleAuthorityDto
} from '@flyfreely-portal-ui/flyfreely';
import { AdditionalAuthorityNameIdWithRequiresApproval } from '../mission-edit-v2-dialogue.component';

@Component({
    selector: 'mission-authority-details-panel',
    templateUrl: './mission-authority-details.component.html',
    styleUrls: ['../../styles.scss']
})
export class MissionAuthorityDetailsComponent {
    @Input() workflow: InUseMissionWorkflowVersionDto;
    @Input() missionWorkflowPrimaryAuthority: OrganisationAuthorityDto;
    @Input() additionalAuthorityIds: number[];
    @Input() authorityIndicatorLookup: { [authorityId: number]: string };
    @Input() availableAuthorityLookup: {
        [authorityId: number]: AdditionalAuthorityNameIdWithRequiresApproval;
    };
    @Input() allAdditionalAuthoritiesLookup: {
        [authorityId: number]: SimpleAuthorityDto;
    };
    @Input() showAdditionalAuthorities: boolean;
    @Input() setDisabled: boolean;

    @Output() requestShowAuthorityDetails =
        new EventEmitter<SimpleAuthorityDto>();

    showAuthorityDetails(authority: SimpleAuthorityDto) {
        if (authority != null) {
            this.requestShowAuthorityDetails.emit(authority);
        }
    }
}
